import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import api from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import CountdownBanner from "@/components/site/CountdownBanner";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import InstagramFeed from "@/components/site/InstagramFeed";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import Testimonials from "@/components/site/Testimonials";
import WinnerSpotlightBand from "@/components/site/WinnerSpotlightBand";
import Blog from "@/components/site/Blog";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [site, setSite] = useState(null);
  const [igFeed, setIgFeed] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/site"), api.get("/instagram/feed?limit=6").catch(() => ({ data: null }))])
      .then(([siteRes, igRes]) => {
        setSite(siteRes.data);
        setIgFeed(igRes.data);
      })
      .catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div data-testid="home-error" className="flex h-screen items-center justify-center bg-[#050505] text-neutral-400">
        The royal court is momentarily unreachable. Please refresh.
      </div>
    );
  }

  if (!site) {
    return (
      <div data-testid="home-loading" className="flex h-screen flex-col items-center justify-center gap-6 bg-[#050505]">
        <Crown className="animate-crown-pulse h-12 w-12 text-[#D4AF37]" strokeWidth={1} />
        <span className="font-script text-3xl text-[#D4AF37]/80">D'La Valentina</span>
      </div>
    );
  }

  const { settings, services, gallery, testimonials, posts } = site;

  return (
    <div data-testid="home-page" className="bg-[#050505] text-white">
      <Navbar />
      <Hero settings={settings} />
      <Marquee text={settings.marquee_text} />
      <CountdownBanner settings={settings} />
      <About settings={settings} />
      <Services services={services} />
      <Gallery gallery={gallery} />
      <InstagramFeed feed={igFeed} instagramUrl={settings.instagram_url || "https://www.instagram.com/valentina.mishra"} />
      <Testimonials testimonials={testimonials} />
      <WinnerSpotlightBand />
      <Blog posts={posts} />
      <Contact settings={settings} />
      <Footer settings={settings} />
      <WhatsAppButton />
    </div>
  );
}
